<template>
  <v-icon color="error" :title="title">{{ icon }}</v-icon>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    title() {
      if (this.item.novo) {
        return "Novo";
      }
      if (this.item.remover) {
        return "Marcado para remoção";
      }
      if (this.item.editar) {
        return "Editado";
      }
      return "";
    },
    icon() {
      if (this.item.novo) {
        return "mdi-new-box";
      }
      if (this.item.remover) {
        return "mdi-delete-outline";
      }
      if (this.item.editar) {
        return "mdi-pencil-outline";
      }
      return "";
    }
  }
};
</script>
